import { ApiRolesState, GetRolesPayload } from './ApiRolesSlice.types'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { State, ThunkErrorObject } from '../../../store.types'
import { ApiFetchRolesResponse } from '../../../../api/services/roles/roles.types'
import { toast } from 'react-toastify'
import i18next from 'i18next'
import { apiFetchRoles } from 'src/api'

const initialState: ApiRolesState = {
  ApiRolesStates: []
}

export const getRoles = createAsyncThunk<
  ApiFetchRolesResponse,
  GetRolesPayload,
  { rejectValue: ThunkErrorObject }
>('apiRoles/fetchRoles', async ({ userToken, windowId }, thunkApi) => {
  try {
    const serverPath = (thunkApi.getState() as State).user.serverUrl
    const response = await apiFetchRoles(userToken, serverPath)
    if (!response.data.ok) {
      toast.error(i18next.t('errors.an_error_has_ocurred'))
      return thunkApi.rejectWithValue({
        message: 'errors.an_error_has_ocurred',
        windowId
      })
    }
    return response.data
  } catch (error) {
    return thunkApi.rejectWithValue({
      message: 'errors.an_error_has_ocurred',
      windowId
    })
  }
})

export const apiRolesSlice = createSlice({
  name: 'apiRoles',
  initialState,
  reducers: {
    removeApiRoleState: (
      state,
      { payload }: PayloadAction<{ windowId: string }>
    ) => {
      state.ApiRolesStates = state.ApiRolesStates.filter(
        (apiRoleState) => apiRoleState.windowId !== payload.windowId
      )
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      getRoles.pending,
      (
        state,
        {
          meta: {
            arg: { windowId }
          }
        }
      ) => {
        const apiRoleState = state.ApiRolesStates.find(
          (apiRole) => apiRole.windowId === windowId
        )
        if (apiRoleState != null) {
          apiRoleState.loading = true
        } else {
          state.ApiRolesStates.push({
            loading: true,
            type: '',
            errorList: [],
            environmentDataAuxList: [],
            permissionAuxList: [],
            permissionCategoryList: [],
            reportAuxList: [],
            rolePredefinedList: [],
            windowId
          })
        }
      }
    )
    builder.addCase(
      getRoles.fulfilled,
      (
        state,
        {
          meta: {
            arg: { windowId }
          }
        }
      ) => {
        const apiRoleStateId = state.ApiRolesStates.findIndex(
          (apiRole) => apiRole.windowId === windowId
        )
        const apiRoleState = state.ApiRolesStates[apiRoleStateId]
        if (apiRoleState) {
          apiRoleState.loading = false
        }
      }
    )
  }
})

export const { removeApiRoleState } = apiRolesSlice.actions
